<div class="nav-top">
    <div class="item" [ngClass]="{'item-active':activeRoute=='users'}" (click)="goto('users')">Users</div>
    <div class="item" [ngClass]="{'item-active':activeRoute=='advertisement'}" (click)="goto('advertisement')">Advertisement</div>
</div>
<router-outlet></router-outlet>